<div [ngClass]="{'border-top-0': !inTab}" class="border-box-darkgrey p-xl-4">
  <div class="row">
    <div class="col mb-4">
      <h5>As minhas alterações / logótipos</h5>
      <div class="border-box-grey bg-extralight text-sm-1">
        <p>Estes são os diversos <strong>logótipos disponíveis para cada formato de campanha</strong>.<br>
          Pode registar o número de logótipos que desejar, associando-os a um formato específico de campanha.<br>
          Não se esqueça de remover os logótipos que já não são válidos e que não são utilizados.</p>
        <p class="mb-0">Indicamos-lhe as dimensões que deve considerar ao associar cada logotipo ao formato de campanha pretendido</p>
      </div>
      <div class="table-responsive-sm">
        <table id="tblMedidasLogo" class="table mt-4 w-100">
          <thead>
            <tr>
              <th class="text-center border-0 strong">TAMANHO DO<br>LOGÓTIPO EM LONA</th>
              <th class="text-center border-0 strong">MEDIDA<br>LOGÓTIPO IMPRENSA</th>
              <th class="text-center border-0 strong">TAMANHO DO<br>LOGÓTIPO FOLHETO</th>
              <th class="text-center border-0 strong">TAMANHO DO<br>LOGÓTIPO E-MAIL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center text-sm-2 bg-extralight border-0">170 mm largura x 150 mm altura</td>
              <td class="text-center text-sm-2 bg-extralight border-0">94 mm largura x 99 mm altura</td>
              <td class="text-center text-sm-2 bg-extralight border-0">94 mm largura x 99 mm altura</td>
              <td class="text-center text-sm-2 bg-extralight border-0">245 mm largura x 80 mm altura</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <div class="col-auto">
      <a class="btn-black mb-3" data-bs-toggle="modal" data-bs-target="#ModalsolicitarLogo">Pedido de novo logótipo STIHL</a><br>
      <a class="btn-black" (click)="AddLogo()">Adicionar logótipo</a>
    </div>
  </div>
  <div class="row" *ngIf="model && editable">

    <form [formGroup]="dataform" (ngSubmit)="SaveLogo()" *ngIf="addingLogo">
      <hr>
      <div class="lead"><strong>Adicionar logótipo</strong></div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label class="form-label text-sm-2 mb-0" for="IdCampaignMaterialMedia">Meio</label>
            <select2 formControlName="IdCampaignMaterialMediaType" id="IdCampaignMaterialMedia" [data]="campaignmediaTypes" [placeholder]="'Tipo de Meio'" class="select2"></select2>
          </div>

          <div class="form-group mb-3">
            <label class="form-label text-sm-2 mb-0" for="Description">Descrição</label>
            <textarea formControlName="Description" type="text" class="form-control" id="Description" placeholder="Descrição do logótipo">
            </textarea>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <ngx-dropzone (change)="onFileSelect($event)" [multiple]="false" accept="image/jpeg,image/jpg,image/png,image/gif">
            <ngx-dropzone-label>
              <div>arraste a imagem do seu logótipo para upload<br>ou</div><span class="btn">Selecionar imagem</span>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemoveFile(f)">
            </ngx-dropzone-image-preview>
          </ngx-dropzone>
        </div>
      </div>
      <div class="row mb-3">
        <div class="row_buttons">
          <button type="submit" class="btn-orange">GUARDAR</button>
          <button type="button" class="btn-black-border" (click)="CancelAddLogo()">CANCELAR</button>
        </div>
      </div>
    </form>

  </div>
  <hr>
  <div class="table-responsive" *ngIf="model">
    <table id="tblDistributorLogo" class="table dataTable w-100">
      <thead>
        <tr>
          <th class="w-10">Meio</th>
          <th>Descrição</th>
          <th class="text-center w-30">Logótipo</th>
          <th class="text-center w-8">Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let logo of model.StihlDistributorLogos">
          <td class="bg-extralight">
            {{logo.CampaignMaterialMediaType}}
          </td>
          <td class="text-left bg-extralight">
            {{logo.Description}}
          </td>
          <td class="text-center bg-extralight">
            <img [src]="logo.FileLogo.FileUri" width="40%" />
          </td>
          <td class="text-start bg-extralight">
            <a [href]="logo.FileLogo.FileUri" class="btn-transparent btn-sm btn-icon">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_download_auto.svg#img" href="assets/images/icons/ico_download_auto.svg#img"></use>
                </svg>
              </div>
              Download
            </a>
            <button type="button" (click)="DeleteLogo(logo.IdLogo)" class="btn-transparent btn-sm btn-icon">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_trash_auto.svg#img" href="assets/images/icons/ico_trash_auto.svg#img"></use>
                </svg>
              </div>
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="ModalsolicitarLogo" tabindex="-1" aria-labelledby="ModalsolicitarLogoLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalsolicitarLogoLabel">Pedido de novo logótipo à STIHL</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Solicite um novo desenho de logótipo a <a href="mailto:patricia.bernardo@stihl.pt">patricia.bernardo@stihl.pt</a> na STIHL, indicando o seu código e nome de Concessionário, bem como o formato do material para o qual o está a pedir.
      </div>
      <div class="modal-footer">
        <a class="btn-orange" href="mailto:patricia.bernardo@stihl.pt" target="_blank">Pedir</a>
      </div>
    </div>
  </div>
</div>